module.exports = __webpack_public_path__ + "static/e0ffe88ab357664b9ecfb703037e420e.png";